/* eslint-disable dot-notation */
import { service } from '../api/axios';

export const getEvents = () =>
  service.get('/events').then((response) => response.data);

export const downloadAttendeesList = async (eventId) => {
  const response = await service.get(`/events/${eventId}/attendeesCsv`);
  return response.data;
};

export const putEvent = (eventData) => {
  if (eventData._id) {
    // Update existing event
    return service.put(`/events/${eventData._id}`, eventData).then((response) => response.data);
  } else {
    // Create new event
    return service.post('/events', eventData).then((response) => response.data);
  }
};

export const getEvent = (eventId) =>
  service
    .get(`/events/${eventId}`)
    .then((responseFromAPI) => responseFromAPI.data[0]);

export const joinEventService = (eventId, user) =>
  service
    .put(`/events/${eventId}/join`, user)
    .then((response) => response.data);

export const leaveEventService = (eventId, user) =>
  service
    .put(`/events/${eventId}/leave`, user)
    .then((response) => response.data);

export const deleteEventService = (eventId) =>
  service.delete(`/events/${eventId}`).then((response) => response.data);

export const inviteForEventService = (eventId, userId) =>
  service
    .put(`/events/${eventId}/invite`, { userId })
    .then((responseFromAPI) => responseFromAPI.data);

export const removeInviteForEventService = (eventId, userId) =>
  service
    .put(`/events/${eventId}/removeInvite`, { userId })
    .then((responseFromAPI) => responseFromAPI.data);
